import React from 'react';
import { CardHeader, FormGroup, Input, Button } from 'reactstrap';
import { Delete } from 'react-feather';

const CallFormHeader = ({
    formData,
    handleCustomerTypeChange,
    resetForm,
    callFormState,
}) => {
    return (
        <>
            {['Taslak', 'Yeni Çağrı Formu'].includes(callFormState) && (
                    <CardHeader>
                        <div className="d-flex justify-content-center justify-content-lg-end align-items-center w-100 file-content flex-wrap">
                            <FormGroup className="d-flex align-items-center me-2 mt-3 flex-wrap">
                                <Input
                                    type="select"
                                    id="customerType"
                                    name="customerType"
                                    value={formData.customerType}
                                    onChange={handleCustomerTypeChange}
                                    className="form-control"
                                >
                                    <option value="Bireysel">Bireysel</option>
                                    <option value="Kurumsal">Kurumsal</option>
                                </Input>
                            </FormGroup>
                            <Button color="outline-danger" className="ms-2" onClick={resetForm}>
                                <Delete className="me-2" />
                                Çağrı Formunu Temizle
                            </Button>
                        </div>
                    </CardHeader>
                )}
        </>
    );
};

export default CallFormHeader;
